import { FC, PropsWithChildren, useState } from 'react';

import DashboardContext from '@/context/DashboardContext/DashboardContext';

const DashboardContextProvider: FC<PropsWithChildren<unknown>> = ({
  children,
}) => {
  const [isDashboardCollapsed, setIsDashboardCollapsed] = useState<boolean>();
  const { Provider } = DashboardContext;

  return (
    <Provider value={{ isDashboardCollapsed, setIsDashboardCollapsed }}>
      {children}
    </Provider>
  );
};

export default DashboardContextProvider;
